
import { Button } from "@/components/ui/button";
import { Loader2 } from "lucide-react";

interface FormActionsProps {
  isGenerating: boolean;
}

export const FormActions = ({
  isGenerating,
}: FormActionsProps) => {
  return (
    <div className="space-y-4">
      <Button
        type="submit"
        disabled={isGenerating}
        className="w-full bg-gradient-to-r from-blue-600 to-cyan-500 hover:from-blue-700 hover:to-cyan-600"
      >
        {isGenerating ? (
          <>
            <Loader2 className="mr-2 h-4 w-4 animate-spin" />
            Generating Messages...
          </>
        ) : (
          "Generate Messages"
        )}
      </Button>
    </div>
  );
};
